import find from 'lodash-es/find';
import hookedVariantSelectors from '../../hooks/sections/ProductOverview/variantSelectors';
import get980Inventory from './get980Inventory';

const processVariantSelectors = (type, e) => {
  const variantSelector = e.target;
  const container = variantSelector.closest('[data-section-type="product"]');
  const parentElement = container.parentElement;
  const productJsonElement = parentElement.querySelector('[data-product-json]');
  const optionSelector = variantSelector.closest('[data-custom-option-selector]');
  const shopifySelector = container.querySelector(optionSelector.getAttribute('data-shopify-option-selector'));

  let productJson = {};
  if (productJsonElement) {
    try {
      productJson = JSON.parse(productJsonElement.innerHTML);
    } catch (error) {
      console.error('Error parsing product JSON:', error);
    }
  }

  const quickViewOpened = document.querySelector('[data-quick-view-content]');
  let value;

  const displayVariantSizes = (res) => {
    if (type === 'list') {
      optionSelector.querySelectorAll('[data-custom-variant-selector]').forEach((selector) => {
        selector.classList.remove('ProductOption__variant--selected');
        selector.setAttribute('aria-checked', 'false');
        // selector.setAttribute('tabindex', '-1');
      });
      variantSelector.classList.add('ProductOption__variant--selected');
      variantSelector.setAttribute('aria-checked', 'true');
      // variantSelector.setAttribute('tabindex', '0');
      value = variantSelector.getAttribute('data-value');
    } else if (type === 'select') {
      value = variantSelector.value;
    }

    // eslint-disable-next-line
    if (value === undefined || value === null) {
      // WEIRD BEHAVIOR WITH IOS AND SELECTRIC:
      // We're in the middle of choosing a value via the native select picker, but selectric triggers the change event.
      // We haven't hit "done" yet so the value is technically undefined...we're basically in limbo.
      // It will trigger another change event once we actually make our selection, so this is just extra/premature.
      // Just return so we don't cause problems...the final change event will go through fine.
      return;
    }

    shopifySelector.value = value;
    const event = new Event('change', { bubbles: true });
    shopifySelector.dispatchEvent(event);

    // Check for any invalid/unavailable or sold out options and disable them

    const currentOption1 = container.querySelector('#SingleOptionSelector-0').value;
    const currentOption2 = container.querySelector('#SingleOptionSelector-1').value;
    const currentOption3 = container.querySelector('#SingleOptionSelector-2');
    if (currentOption3) {
      currentOption3.value;
    }

    if (type === 'list') {
      const variantSelectors = container.querySelectorAll('[data-custom-variant-selector]');
      variantSelectors.forEach((selector) => {
        selector.classList.remove('ProductOption__variant--unavailable', 'ProductOption__variant--sold-out');
      });

      variantSelectors.forEach((selector) => {
        const closest_selector = selector
          .closest('[data-custom-option-selector]')
          .getAttribute('data-custom-option-selector');

        // If this product has 2 or more options and this selector is an option 1, just get out of here...we don't need to process this
        if (closest_selector === 'option1' && currentOption2) {
          return;
        }

        // Similar logic but for 3 options
        if ((closest_selector === 'option1' || closest_selector === 'option2') && currentOption3) {
          return;
        }
        let variant_name = selector.getAttribute('data-value');
        if (closest_selector === 'option2') {
          variant_name = `${currentOption1} / ${selector.getAttribute('data-value')}`;
        }

        if (closest_selector === 'option3') {
          variant_name = `${currentOption1} / ${currentOption2} / ${selector.getAttribute('data-value')}`;
        }

        let variant;

        // if international customer, display only 980 inventory
        if (res) {
          variant = res.size[variant_name];

          if (variant === null || variant === undefined) {
            // Doesn't exist at all...unavailable
            selector.classList.add('ProductOption__variant--unavailable');
          } else if (variant <= 0) {
            // Exists, but sold out
            selector.classList.add('ProductOption__variant--sold-out');
          }
        } else {
          variant = find(productJson.variants, {
            title: variant_name,
          });

          if (!variant) {
            // Doesn't exist at all...unavailable
            selector.classList.add('ProductOption__variant--unavailable');
          } else if (!variant.available) {
            // Exists, but sold out
            selector.classList.add('ProductOption__variant--sold-out');
          }
        }
      });

      // Special logic for 3 option products...
      if (currentOption3) {
        container
          .querySelectorAll('[data-custom-option-selector="option2"] [data-custom-variant-selector]')
          .forEach((selector) => {
            const variantPrefix = `${currentOption1} / ${selector.getAttribute('data-value')}`;
            let variantFound = false;
            let variantInStock = false;

            productJson.variants.forEach((_variant) => {
              if (_variant.title.indexOf(variantPrefix) === 0) {
                variantFound = true;
                if (_variant.available) {
                  variantInStock = true;
                }
              }
            });

            if (!variantFound) {
              selector.classList.add('ProductOption__variant--unavailable');
            } else if (!variantInStock) {
              selector.classList.add('ProductOption__variant--sold-out');
            }
          });
      }

      // Are we currently on an unavailable variant? Change immediately if so
      const currentUnavailable = container.querySelector(
        '.ProductOption__variant--unavailable.ProductOption__variant--selected',
      );

      if (currentUnavailable) {
        const option3Variants = Array.from(
          container.querySelectorAll('[data-custom-option-selector="option3"] [data-custom-variant-selector]'),
        );
        const availableOption3Variant = option3Variants.find(
          (variant) => !variant.classList.contains('ProductOption__variant--unavailable'),
        );

        if (availableOption3Variant) {
          availableOption3Variant.click();
          return;
        }

        const option2Variants = Array.from(
          container.querySelectorAll('[data-custom-option-selector="option2"] [data-custom-variant-selector]'),
        );
        const availableOption2Variant = option2Variants.find(
          (variant) => !variant.classList.contains('ProductOption__variant--unavailable'),
        );

        if (availableOption2Variant) {
          availableOption2Variant.click();
          return;
        }
      }
    } else if (type === 'select') {
      let optionNumber = 1;

      if (container.querySelector('[data-custom-option-selector="option2"]')) {
        optionNumber = 2;
      }
      if (container.querySelector('[data-custom-option-selector="option3"]')) {
        optionNumber = 3;
      }

      // TODO: this variable called "selector" and the logic linked to this variable could be removed too.
      const selector = container.querySelector(`[data-custom-option-selector="option${optionNumber}"] select`);
      selector.querySelectorAll('option').forEach((option) => {
        let variant_name = option.value;

        if (optionNumber === 2) {
          variant_name = `${currentOption1} / ${variant_name}`;
        } else if (optionNumber === 3) {
          variant_name = `${currentOption1} / ${currentOption2} / ${variant_name}`;
        }

        const variant = find(productJson.variants, {
          title: variant_name,
        });

        option.disabled = false;

        if (!variant) {
          // Doesn't exist at all...unavailable
          option.disabled = true;
        } else if (!variant.available) {
          // TODO: we replaced the css selector to selector-wrapper instead of selectric-wrapper. But it could be removed
          // because the select HTML tag is not no longer employed
          const liElements = selector.closest('.selector-wrapper').querySelectorAll('li');
          liElements.forEach((li) => {
            if (li.textContent.trim() === option.textContent.trim()) {
              li.classList.add('sold-out');
            }
          });
        }
      });

      // Special logic for 3 option products...
      if (currentOption3) {
        const selector2 = container.querySelector('[data-custom-option-selector="option2"] select');

        selector2.querySelectorAll('option').forEach((option) => {
          const variant_prefix = `${currentOption1} / ${option.value}`;

          let variant_found = false;
          let variant_in_stock = false;

          productJson.variants.forEach((_variant) => {
            if (_variant.title.indexOf(variant_prefix) !== 0) {
              return;
            }

            if (!variant_found) {
              variant_found = true;
            }

            if (_variant.available && !variant_in_stock) {
              variant_in_stock = true;
            }
          });

          option.disabled = false;

          if (!variant_found) {
            // Doesn't exist at all...unavailable
            option.disabled = true;
          } else if (!variant_in_stock) {
            // Exists, but sold out
            // TODO: we replaced the css selector to selector-wrapper instead of selectric-wrapper. But it could be removed
            // because the select HTML tag is not no longer employed
            const liElements = selector2.closest('.selector-wrapper').querySelectorAll('li');
            liElements.forEach((li) => {
              if (li.textContent.trim() === option.textContent.trim()) {
                li.classList.add('sold-out');
              }
            });
          }
        });

        // Are we currently on an unavailable variant? Change immediately if so
        // TODO: we replaced the css selector to selector-wrapper instead of selectric-wrapper. But it could be removed
        // because the select HTML tag is not no longer employed
        const selected_text = selector2.closest('.selector-wrapper').querySelector('.selected').textContent.trim();
        const current_value = selector2.value;
        if (selected_text !== current_value) {
          selector2.selectedIndex = 0;
          const event = new Event('change', { bubbles: true });
          selector2.dispatchEvent(event);
          return;
        }

        selector2.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Are we currently on an unavailable variant? Change immediately if so
      // TODO: we replaced the css selector to selector-wrapper instead of selectric-wrapper. But it could be removed
      // because the select HTML tag is not no longer employed
      const selected_text = selector.closest('.selector-wrapper').querySelector('.selected').textContent.trim();
      const current_value = selector.value;
      if (selected_text !== current_value) {
        selector.selectedIndex = 0;
        const event = new Event('change', { bubbles: true });
        selector.dispatchEvent(event);
        return;
      }

      selector.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  let res = false;
  const country = window.theme.country_iso;

  if (country === 'US') {
    displayVariantSizes(res);
  } else if (window.inventory980 && !quickViewOpened) {
    displayVariantSizes(window.inventory980);
  } else {
    /* eslint-disable-next-line no-async-promise-executor */
    return new Promise(async (resolve, reject) => {
      try {
        res = await get980Inventory(e, false, false);
        console.log(res);
        resolve(res);
        displayVariantSizes(res);
      } catch (error) {
        reject(error);
        displayVariantSizes((res = false));
      }
    });
  }
};

export default function () {
  const variantSelectors = hookedVariantSelectors ? hookedVariantSelectors : processVariantSelectors;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-custom-variant-selector]:not(.ProductOption__variant--unavailable)')) {
      // Get the variant button
      const variantButton = e.target.closest('[data-custom-variant-selector]');

      // Get the product JSON
      const container = variantButton.closest('[data-section-type="product"]');
      const parentElement = container.parentElement;
      const productJsonElement = parentElement.querySelector('[data-product-json]');
      let productJson = {};

      if (productJsonElement) {
        try {
          productJson = JSON.parse(productJsonElement.innerHTML);
        } catch (error) {
          console.error('Error parsing product JSON:', error);
        }
      }

      // Get the option type and value
      const optionSelector = variantButton.closest('[data-custom-option-selector]');
      const optionType = optionSelector.getAttribute('data-custom-option-selector');
      const optionValue = variantButton.getAttribute('data-value');

      // Get current selected options
      const currentOption1 = container.querySelector('#SingleOptionSelector-0')?.value;
      // const currentOption2 = container.querySelector('#SingleOptionSelector-1')?.value;

      // Find the matching variant
      let matchingVariant;
      if (optionType === 'option1' && productJson.variants) {
        // If changing option1, find the first available variant with this option1
        matchingVariant = productJson.variants.find((v) => v.option1 === optionValue && v.available);
      } else if (optionType === 'option2' && productJson.variants && currentOption1) {
        // If changing option2, find the variant with current option1 and this option2
        matchingVariant = productJson.variants.find(
          (v) => v.option1 === currentOption1 && v.option2 === optionValue && v.available,
        );
      }

      // If we found a matching variant, add its barcode to the button
      if (matchingVariant && matchingVariant.barcode) {
        variantButton.setAttribute('data-variant-barcode', matchingVariant.barcode);
      }

      variantSelectors('list', e);
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.closest('[data-custom-variant-selector]')) {
      variantSelectors('select', e);
    }
  });
}
